module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_access_06-714218f7fb928f574eac3b004418c92e.jpg";